// Static mapping of Less color variables (see colors.less) to
// the camelCased object shape that less-var-loader used to export.

const colors = {
  // Brand colors
  brandMarineBlue: '#0e3147',
  brandOrange: '#ff5000',
  brandTeal: '#1a728f',

  // Assorted colors
  colorDanger: '#db2e40',
  colorGray: '#aabecb',
  colorGrayDark1: '#909fa7',
  colorGrayDark2: '#595d6e',
  colorGrayLight: '#ecedf3',
  colorGrayLight1: '#d7d7d7',
  colorSuccess: '#3e9651',
  colorWhite: '#fff',

  // Font colors
  fontColorDanger: '#db2e40',
  fontColorLabel: '#909fa7',
  fontColorLink: '#1a728f',
  fontColorOrange: '#ff5000',
  fontColorPrimary: '#595d6e',
  fontColorSuccess: '#3e9651',

  // Chart colors
  colorBlue: '#1587cf',
  colorBlueLight: '#4dbaff',
  colorMagenta: '#cd34b5',
  colorOrange: '#ff9500',
  colorRossoCorsa: '#d11e15',
  colorYellow: 'goldenrod',
}

export default colors
